import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFaceSad32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconFaceSad32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M26 16c0 5.523-4.477 10-10 10S6 21.523 6 16 10.477 6 16 6s10 4.477 10 10m2 0c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4s12 5.373 12 12m-15.5-1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m8.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-10.447 9.394a1 1 0 0 0 1.34-.442h8.215a1 1 0 0 0 1.786-.9L21 22l.894-.448v-.001l-.002-.002-.002-.005-.007-.013-.02-.04-.07-.124a6 6 0 0 0-.26-.406 7.3 7.3 0 0 0-1.042-1.196C19.544 18.891 18.063 18 16 18s-3.544.891-4.49 1.765a7.3 7.3 0 0 0-1.042 1.196 6 6 0 0 0-.33.53l-.021.04-.007.013-.002.005-.002.002c0 .001 0 .002.894.449l-.894-.447a1 1 0 0 0 .447 1.341m1.34-.442h8.215l-.006-.011-.037-.066a4 4 0 0 0-.175-.273 5.3 5.3 0 0 0-.756-.867C18.456 20.609 17.437 20 16 20s-2.456.609-3.134 1.235a5.3 5.3 0 0 0-.756.867 4 4 0 0 0-.212.339z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFaceSad32);
